// @flow
import React from 'react'
import { defineMessages, useIntl } from 'react-intl'
import Company from '../views/company'
import Head from '@components/common/head'

const messages = defineMessages({
  title: {
    id: 'about.title',
    defaultMessage: 'About SOUND ON LIVE, Inc.',
  },
  description: {
    id: 'about.description',
    defaultMessage: 'SOUND ON LIVE, Inc. company information',
  },
})

const CompanyPage = () => {
  const intl = useIntl()
  return (
    <div className="container-sm pt-5">
      <Head
        title={intl.formatMessage(messages.title)}
        description={intl.formatMessage(messages.description)}
        url="https://www.soundonlive.com/about"
      />
      <Company />
    </div>
  )
}

export const getStaticProps = () => ({
  props: {
    breadcrumbs: [{ label: 'SOUND ON LIVE, Inc.' }],
  },
})

export default CompanyPage
